import React, { Fragment, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { currentRouteSet } from "../../actions/actions";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import {
  pathSpliter,
  checkAuthBranchWare,
  dateTimeFormat,
  checkIntNum,
  currentDateTime,
  getDateTimeFromISODT,
} from "../../lib/functions";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { APP_URL, API_URL } from "../../config";
import { useHistory } from "react-router-dom";

import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";

import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import "./components/stock.css";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import swal from "sweetalert";
import { CardContent } from "@material-ui/core";

const TransferEntry = ({ location, currentRoute, currentRouteSet, authInfo }) => {
  const classes = useStyles();
  const [selectedDate, handleDateChangeSet] = useState(currentDateTime);

  const history = useHistory();

  // States start
  let [cart, cartSet] = useState([]);
  let [employees, employeesSet] = useState([]);
  let [branches, branchesSet] = useState([]);
  let [warehouses, warehousesSet] = useState([]);
  let [products, productsSet] = useState([]);

  let [selectedEmployee, selectedEmployeeSet] = useState(null);
  let [selectedProduct, selectedProductSet] = useState(null);
  let [selectedBranch, selectedBranchSet] = useState(null);
  let [selectedWarehouse, selectedWarehouseSet] = useState(null);



  let [fromFloors, fromFloorsSet] = useState([])
  let [fromRacks, fromRacksSet] = useState([])
  let [toFloors, toFloorsSet] = useState([])
  let [toRacks, toRacksSet] = useState([])

  let [fromFloor, fromFloorSet] = useState(null)
  let [fromRack, fromRackSet] = useState(null)
  let [toFloor, toFloorSet] = useState(null)
  let [toRack, toRackSet] = useState(null)

  const fromFloorRef = useRef(null)
  const fromRackRef = useRef(null)
  const toFloorRef = useRef(null)
  const toRackRef = useRef(null)


  let [product_rate, product_rate_set] = useState(0);
  let [product_qty, product_qty_set] = useState("");
  let [product_total, product_total_set] = useState(0);

  let [product_stock_status, product_stock_status_set] =
    useState("stock status");
  let [product_stock_qty, product_stock_qty_set] = useState("stock qty");
  let [product_unit, product_unit_set] = useState("unit");
  let [product_purchase_rate, product_purchase_rate_set] =
    useState("purchase rate");

  let [note, note_set] = useState("");
  let [total, total_set] = useState(0);

  let productRef = useRef(null);
  let branchRef = useRef(null);
  let warehouseRef = useRef(null);
  let qtyRef = useRef(null);
  let addToCartRef = useRef(null);
  let dateRef = useRef(null);
  let transferRef = useRef(null);

  let [transferFormAction, transferFromActionSet] = useState("create");
  let [transferId, transferIdSet] = useState(0);

  // State End

  const resetTransferFields = () => {
    fromFloorsSet([]);
    fromRacksSet([]);
    toFloorsSet([]);
    toRacksSet([]);

    fromFloorSet(null);
    fromRackSet(null);
    toFloorSet(null);
    toRackSet(null);
    product_qty_set("")
    product_stock_qty_set("stock qty")
  };

  const loadTransferLocationInfo = async (productId, floorId, rackId) => {
    if (!productId || !floorId || !rackId) {
      product_stock_qty_set("stock qty");
      product_rate_set(0);
      return;
    }

    try {
      const res = await axios.post(
        `${API_URL}/api/get-product-location`,
        { productId },
        { headers: { "auth-token": authInfo.token } }
      );

      const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
      const matchedRow = rows.find((row) => {
        return (
          Number(row?.prod_floor_id) === Number(floorId) &&
          Number(row?.prod_rack_id) === Number(rackId)
        );
      });

      if (!matchedRow) {
        product_stock_qty_set(0);
        product_rate_set(0);
        product_purchase_rate_set(0);
        return;
      }

      const exactQty = parseFloat(matchedRow?.prod_qty ?? 0);
      const exactPurchaseRate = parseFloat(matchedRow?.prod_purchase_rate ?? 0);
      const exactAverageRate = parseFloat(matchedRow?.average_purchase_rate ?? 0);

      product_stock_qty_set(Number.isFinite(exactQty) ? exactQty : 0);
      product_rate_set(Number.isFinite(exactPurchaseRate) ? exactPurchaseRate : 0);
      product_purchase_rate_set(Number.isFinite(exactAverageRate) ? exactAverageRate : 0);
    } catch (error) {
      console.error("Error loading transfer location info:", error);
      product_stock_qty_set(0);
      product_rate_set(0);
      product_purchase_rate_set(0);
    }
  };


  // Methods  start
  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
    getProducts();
    getBranches();
    // getWarehouses()
    getEmployees();
    if (pathSpliter(location.pathname, 3) != undefined) {
      transferFromActionSet("update");
      transferIdSet(parseFloat(pathSpliter(location.pathname, 3)));
      getTransfer();
    }
  }, []);

  // Calculate total
  let getTransfer = async () => {
    await axios
      .post(
        `${API_URL}/api/get-product-transfers`,
        { transferId: parseFloat(pathSpliter(location.pathname, 3)) },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        let transfer = res.data.message[0];
        let transferDetails = res.data.message[0].details;

        handleDateChangeSet(transfer.transfer_c_isodt);
        selectedBranchSet({
          branch_name: transfer.branch_name,
          branch_id: transfer.transfer_b_to,
        });
        selectedWarehouseSet({
          warehouse_name: transfer.warehouse_name,
          warehouse_id: transfer.transfer_w_to,
        });
        selectedEmployeeSet({
          employee_id: transfer.transfer_c_by,
          employee_name: transfer.employee_name,
        });
        note_set(transfer.transfer_note);
        let newCart = transferDetails.map((ele) => {
          let product = {
            prod_id: ele.transfer_prod_id,
            prod_name: ele.prod_name,
            prod_qty: ele.transfer_qty,
            prod_purchase_rate: ele.transfer_pur_rate,
            prod_total: ele.transfer_total,

            from_floor_id: ele.from_floor,
            from_rack_id: ele.from_rack,
            to_floor_id: ele.to_floor,
            to_rack_id: ele.to_rack,

            from_floor_name: ele.from_floor_name || "",
            from_rack_name: ele.from_rack_name || "",
            to_floor_name: ele.to_floor_name || "",
            to_rack_name: ele.to_rack_name || ""
          };
          return product;
        });
        cartSet(newCart);
      });
  };

  useEffect(() => {
    let total = cart.reduce((prev, curr) => {
      return prev + parseFloat(curr.prod_total);
    }, 0);
    total_set(total);
  }, [cart]);

  let employeeRef = useRef(null);

  useEffect(() => {
    product_total_set(parseFloat(product_rate || 0) * parseFloat(product_qty || 0));
  }, [product_qty, product_rate]);

  useEffect(() => {

    toFloorsSet([]);
    toRacksSet([]);
    toFloorSet(null);
    toRackSet(null);

  }, [selectedBranch])

  useEffect(() => {
    resetTransferFields(); // Clear from/to floor/rack selections

    if (selectedProduct != null) {
      axios
        .post(
          `${API_URL}/api/get-product-floors`,
          { productId: selectedProduct.prod_id },
          { headers: { "auth-token": authInfo.token } }
        )
        .then((res) => {
          fromFloorsSet(res.data.data)
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      fromFloorsSet([])
    }
  }, [selectedProduct]);

  useEffect(() => {
    fromRacksSet([]);
    fromRackSet(null);

    toFloorSet(null);
    toRackSet(null);
    toFloorsSet([]);
    toRacksSet([]);

    product_stock_qty_set("stock qty");
    product_rate_set(0);
    product_purchase_rate_set(0);

    if (fromFloor != null && selectedProduct != null) {
      axios
        .post(
          `${API_URL}/api/get-product-racks`,
          {
            productId: selectedProduct.prod_id,
            floorId: fromFloor.prod_floor_id,
          },
          { headers: { "auth-token": authInfo.token } }
        )
        .then((res) => {
          fromRacksSet(res.data.data);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }, [fromFloor, selectedProduct]);

  useEffect(() => {
    toFloorSet(null);
    toRackSet(null);
    toFloorsSet([])
    toRacksSet([])

    if (!fromRack || !fromFloor) return;

    axios
      .post(
        `${API_URL}/api/get-floors`,
        {
          branchId: selectedBranch.branch_id,
          "select-type": "active"
        },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        // if(selectedBranch?.branch_id === authInfo.userInfo.user_branch_id){
        //   const filtered = (fromRacks?.length === 1 && fromFloor) 
        //                   ? res.data.message.filter( f => f.prod_floor_id != fromFloor.prod_floor_id) : res.data.message
        //   toFloorsSet(filtered)
        // }else{
        toFloorsSet(res.data.message)
        // }
      })
      .catch((error) => {
        console.error("Error:", error);
      });


  }, [fromRack, fromFloor, selectedBranch]);



  useEffect(() => {
    toRacksSet([])
    toRackSet(null);

    if (!toFloor) {
      toRacksSet([]);
      return;
    }

    axios
      .post(
        `${API_URL}/api/get-racks`,
        {
          floorId: toFloor.prod_floor_id,
          branchId: selectedBranch.branch_id,
          "select-type": "active"
        },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        if (selectedBranch?.branch_id === authInfo.userInfo.user_branch_id) {
          toRacksSet(res.data.message.filter(r => r.prod_rack_id != fromRack.prod_rack_id))
        } else {
          toRacksSet(res.data.message)
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    toRacksSet([]);
  }, [toFloor, toFloors, fromFloor, fromFloors, selectedProduct, selectedBranch]);


  useEffect(() => {
    if (!selectedProduct || !fromFloor || !fromRack) {
      product_stock_qty_set("stock qty");
      product_rate_set(0);
      product_purchase_rate_set(0);
      return;
    }

    loadTransferLocationInfo(
      selectedProduct.prod_id,
      fromFloor.prod_floor_id,
      fromRack.prod_rack_id
    );
  }, [fromFloor, fromRack, selectedProduct]);


  let getEmployees = async () => {
    await axios
      .post(
        `${API_URL}/api/get-employees`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        employeesSet(res.data.message);
      });
  };

  let getBranches = async () => {
    await axios
      .post(
        `${API_URL}/api/get-branches`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        branchesSet(res.data.message);
      });
  };

  //  let getWarehouses = async ()=>{
  //   await axios.post(`${API_URL}/api/get-warehouses`,{'select-type':'active'},{headers:{'auth-token':authInfo.token}}).then(res=>{
  //        warehousesSet(res.data.message)
  //  })
  //  }

  let getProducts = async () => {
    await axios
      .post(
        `${API_URL}/api/get-individual-products`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => [productsSet(res.data.message)]);
  };

  let productToCart = () => {
    if (selectedProduct == null) {
      swal({ title: "Select Product", icon: "warning" });
      return false;
    }
    if (!fromFloor || !fromRack || !toFloor || !toRack) {
      swal({ title: "All floor and rack fields are required", icon: "warning" });
      return false;
    }

    if (fromFloor.prod_floor_id === toFloor.prod_floor_id &&
      fromRack.prod_rack_id === toRack.prod_rack_id) {
      swal({ title: "Source and destination cannot be the same", icon: "warning" });
      return false;
    }
    if (parseFloat(product_rate) <= 0 || product_rate == '') {
      swal({ title: 'Purchase Rate is Invalid.', icon: 'warning' }); return false;
    }
    if (parseFloat(product_qty) <= 0 || product_qty == "") {
      swal({ title: "Quantity is Invalid ", icon: "warning" });
      return false;
    }
    if (
      parseFloat(product_qty) > parseFloat(product_stock_qty) ||
      parseFloat(product_stock_qty) <= 0
    ) {
      swal({ title: "Stock Unavailable", icon: "warning" });
      return false;
    }
    const transferRate = parseFloat(product_rate || 0);
    const transferQty = parseFloat(product_qty || 0);
    const transferTotal = transferRate * transferQty;

    let checkProdExist = cart.findIndex((curr) => {
      if (curr.prod_id == selectedProduct.prod_id) {
        return true;
      }
    });
    if (checkProdExist > -1) {
      swal({ title: "Product already exist in cart.", icon: "warning" });
      return false;
    }
    cartSet([
      ...cart,
      {
        prod_id: selectedProduct.prod_id,
        prod_name: selectedProduct.prod_name,
        prod_brand: selectedProduct.prod_brand_name,
        prod_qty: product_qty,
        prod_purchase_rate: transferRate,
        prod_total: transferTotal,

        from_floor_id: fromFloor?.prod_floor_id,
        from_floor_name: fromFloor?.prod_floor_name,
        from_rack_id: fromRack?.prod_rack_id,
        from_rack_name: fromRack?.prod_rack_name,

        to_floor_id: toFloor?.prod_floor_id,
        to_floor_name: toFloor?.prod_floor_name,
        to_rack_id: toRack?.prod_rack_id,
        to_rack_name: toRack?.prod_rack_name
      }
    ]);
    product_rate_set(0);
    product_qty_set("");
    product_total_set(0);
    selectedProductSet(null);
    productRef.current.focus();
  };

  let cartFromRemove = (index) => {
    let hardCopy = [...cart];
    hardCopy.splice(index, 1);
    cartSet(hardCopy);
  };

  let defaultWarehouse = {
    warehouse_name: "Without Warehouse",
    warehouse_id: 0,
  };

  const [purchaseRateShow, purchaseRateShowSet] = useState(true);
  const [saveLoading, saveLoadingSet] = useState(false);

  let purchaseRateShowAction = () => {
    if (purchaseRateShow == true) {
      purchaseRateShowSet(false);
    } else {
      purchaseRateShowSet(true);
    }
  };

  let transferAction = async () => {
    if (selectedBranch == null) {
      swal({ title: "Branch is required.", icon: "warning" });
      return false;
    }
    if (selectedWarehouse == null) {
      selectedWarehouseSet(defaultWarehouse);
    }

    if (cart.length == 0) {
      swal({ title: "Cart is Empty.", icon: "warning" });
      return false;
    }

    if (selectedEmployee == null) {
      swal({ title: "Employee Required.", icon: "warning" });
      return false;
    }

    let transfer = {
      transfer_b_to: selectedBranch.branch_id,
      transfer_w_to:
        selectedWarehouse == null ? 0 : selectedWarehouse.warehouse_id,
      transfer_note: note,
      transfer_c_by: selectedEmployee.employee_id,
      transfer_amount: total,
      transfer_c_isodt: selectedDate,
      transfer_id: transferId,
    };

    let url = `/api/transfer-add`;
    if (transferFormAction == "update") {
      url = `/api/transfer-update`;
    }
    saveLoadingSet(true);
    await axios
      .post(
        `${API_URL}${url}`,
        { cart, transfer },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${res.data.message.msg} successfully. Do you want to view invoice?`,
            icon: "success",
            buttons: true,
          }).then((confirm) => {
            if (confirm) {
              history.push(
                `/stock/transfer-invoice/${res.data.message.transferId}`
              );
            } else {
              window.location.reload();
            }
          });
        }
        saveLoadingSet(false);
      }).catch((error) => {
        swal({ title: `${error.response.data.message}`, icon: "error" })
        saveLoadingSet(false);
      });
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={3} style={{ marginTop: "-20px" }}>
        <Grid item xs={12} sm={8}>
          <Paper className={classes.paper}>
            <h4
              style={{
                textAlign: "left",
                margin: 0,
                padding: 0,
                marginBottom: "3px",
              }}
            >
              Transfer & product information
            </h4>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={5}>
                <Grid item xs={12} sm={12} style={{ marginBottom: "10px" }}>
                  <Autocomplete
                    autoHighlight={true}
                    size="small"
                    openOnFocus={true}
                    style={{ width: "100%" }}
                    options={branches}
                    value={selectedBranch}
                    disabled={transferFormAction === "update" && selectedBranch?.branch_id === authInfo.userInfo.user_branch_id}
                    onChange={(e, branch) => {
                      selectedBranchSet(branch)
                    }}
                    getOptionLabel={(option) => option.branch_name}
                    renderInput={(params) => (
                      <TextField
                        inputRef={branchRef}
                        onKeyDown={(e) => {
                          if (e.key == "Enter")
                            employeeRef.current.focus();
                        }}
                        {...params}
                        label="Transfer To Branch"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={12} style={{ display: "none" }}>
                  <Autocomplete
                    autoHighlight={true}
                    size="small"
                    openOnFocus={true}
                    style={{ width: "100%" }}
                    options={warehouses}
                    value={selectedWarehouse}
                    onChange={(e, warehouse) => {
                      if (warehouse == null) {
                        selectedWarehouseSet(defaultWarehouse);
                      } else {
                        selectedWarehouseSet(warehouse);
                      }
                    }}
                    getOptionLabel={(option) => option.warehouse_name}
                    renderInput={(params) => (
                      <TextField
                        inputRef={warehouseRef}
                        onKeyDown={(e) => {
                          productRef.current.focus();
                        }}
                        {...params}
                        label="Transfer To Warehouse"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={12} style={{ marginBottom: "25px" }}>
                  <Autocomplete
                    size="small"
                    onKeyDown={(e) => {
                      if (e.key == "Enter") {
                        dateRef.current.focus();
                      }
                    }}
                    value={selectedEmployee}
                    openOnFocus={true}
                    autoHighlight={true}
                    style={{ width: "100%", height: "20px" }}
                    options={employees}
                    onChange={(e, employee) => {
                      selectedEmployeeSet(employee);
                    }}
                    getOptionLabel={(option) => option.employee_name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        inputRef={employeeRef}
                        label="Transfer By"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} sm={5} spacing={3}>
                <Autocomplete
                  openOnFocus={true}
                  autoHighlight={true}
                  style={{ width: "100%", height: "20px", marginBottom: "10px" }}
                  options={products}
                  disabled={selectedBranch === null}
                  value={selectedProduct}
                  size="small"
                  getOptionLabel={(option) => `${option?.prod_code || ""} ${option?.prod_name || ""}`.trim()}
                  onChange={(e, product) => {
                    if (product == null) {
                      selectedProductSet(null);
                      product_rate_set(0);
                      product_total_set(0);
                      product_stock_qty_set("stock qty");
                      product_purchase_rate_set(0);
                      return false;
                    }
                    selectedProductSet(product);
                    product_rate_set(0);
                    product_purchase_rate_set(0);
                    product_stock_qty_set("stock qty");
                    product_total_set(0);
                    fromFloorRef.current.focus();
                  }}
                  renderInput={(params) => (
                    <TextField
                      inputRef={productRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          fromFloorRef.current.focus();
                        }
                      }}
                      {...params}
                      label="choose a product"
                      variant="outlined"
                    />
                  )}
                />
                <br />
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      openOnFocus={true}
                      autoHighlight={true}
                      style={{ width: "100%", height: "20px", marginBottom: "10px" }}
                      disabled={selectedProduct === null}
                      options={fromFloors}
                      value={fromFloor}
                      size="small"
                      getOptionLabel={(option) => option?.prod_floor_name ?? ""}
                      onChange={(e, floor) => {
                        if (floor == null) {
                          fromFloorSet(null);
                          return false;
                        }

                        fromFloorSet(floor);
                        fromRackRef.current.focus();
                      }}
                      renderInput={(params) => (
                        <TextField
                          inputRef={fromFloorRef}
                          onKeyDown={(e) => {
                            if (e.key == "Enter") {
                              fromRackRef.current.focus();
                            }
                          }}
                          {...params}
                          label="choose source floor"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      openOnFocus={true}
                      autoHighlight={true}
                      style={{ width: "100%", height: "20px" }}
                      disabled={fromFloor === null}
                      options={fromRacks}
                      value={fromRack}
                      size="small"
                      getOptionLabel={(option) => option?.prod_rack_name ?? ""}
                      onChange={(e, rack) => {
                        if (rack == null) {
                          fromRackSet(null);
                          return false;
                        }
                        fromRackSet(rack);
                        if (toFloorRef.current) {
                          toFloorRef.current.focus();
                        }

                      }}
                      renderInput={(params) => (
                        <TextField
                          inputRef={fromRackRef}
                          onKeyDown={(e) => {
                            if (e.key == "Enter" && toFloorRef.current) {
                              toFloorRef.current.focus();
                            }
                          }}
                          {...params}
                          label="choose source rack"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <br />
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      openOnFocus={true}
                      autoHighlight={true}
                      style={{ width: "100%", height: "20px" }}
                      disabled={fromRack === null}
                      options={toFloors}
                      value={toFloor}
                      size="small"
                      getOptionLabel={(option) => option?.prod_floor_name ?? ""}
                      onChange={(e, floor) => {
                        if (floor == null) {
                          toFloorSet(null);
                          return false;
                        }

                        toFloorSet(floor);
                        toRackRef.current.focus();
                      }}
                      renderInput={(params) => (
                        <TextField
                          inputRef={toFloorRef}
                          onKeyDown={(e) => {
                            if (e.key == "Enter") {
                              toRackRef.current.focus();
                            }
                          }}
                          {...params}
                          label="choose target floor"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      inpurRef={toRackRef}
                      openOnFocus={true}
                      autoHighlight={true}
                      style={{ width: "100%", height: "20px" }}
                      disabled={toFloor === null}
                      options={toRacks}
                      value={toRack}
                      size="small"
                      getOptionLabel={(option) => option?.prod_rack_name ?? ""}
                      onChange={(e, rack) => {
                        if (rack == null) {
                          toRackSet(null);
                          return false;
                        }

                        toRackSet(rack);
                        qtyRef.current.focus();
                      }}
                      renderInput={(params) => (
                        <TextField
                          inputRef={toRackRef}
                          onKeyDown={(e) => {
                            if (e.key == "Enter") {
                              qtyRef.current.focus();
                            }
                          }}
                          {...params}
                          label="choose target rack"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <br />
                <Grid container>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      type="number"
                      label="quantity"
                      variant="outlined"
                      className={classes.inputField}
                      value={product_qty}
                      onChange={(e) => {
                        product_qty_set(e.target.value);
                      }}
                      inputRef={qtyRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          addToCartRef.current.click();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={1}></Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Total amount"
                      variant="outlined"
                      value={product_total}
                      onChange={(e) => {
                        const value = e.target.value;
                        product_total_set(value);
                      }}
                      disabled={true}
                      className={classes.inputField}
                    />
                  </Grid>
                </Grid>

                <Grid container>
                  <Button
                    style={{
                      marginTop: "5px",
                      marginLeft: "auto",
                      fontSize: "10px",
                    }}
                    buttonRef={addToCartRef}
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => productToCart()}
                    className={classes.button}
                    startIcon={<SaveIcon />}
                  >
                    Add To Cart
                  </Button>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={2}>
                <strong
                  style={{
                    color:
                      fromRack != null
                        ? parseFloat(product_stock_qty) > 0
                          ? "green"
                          : "red"
                        : "green",
                    fontSize: "12px",
                  }}
                  className={"stock-info-msg"}
                >
                  {fromRack != null
                    ? parseFloat(product_stock_qty) > 0
                      ? "Total Stock Available"
                      : "Stock Unavailable"
                    : "Stock Status"}
                </strong>
                <div className={"stock-info"}>
                  <strong
                    style={{
                      color:
                        fromRack != null
                          ? parseFloat(product_stock_qty) > 0
                            ? "green"
                            : "red"
                          : "green",
                      fontSize: "12px",
                    }}
                  >
                    {product_stock_qty}
                  </strong>
                  <p style={{ color: "#005600", fontSize: "12px" }}>
                    {selectedProduct != null
                      ? selectedProduct.prod_unit_name
                      : "Unit Name"}
                  </p>
                </div>
              <div
                  className={"stock-info-purchaserate"}
                  onClick={() => {
                    purchaseRateShowAction();
                  }}
                >
                  <input
                    type={purchaseRateShow ? "password" : "text"}
                    value={
                      selectedProduct != null
                        ? parseFloat(product_rate || 0).toFixed(2)
                        : "Purchase Rate"
                    }
                    disabled
                  ></input>
                </div>
              </Grid>
            </Grid>
          </Paper>

          <Grid container>
            <Grid item xs={12}>
              <Paper className={classes.paper} style={{ marginTop: "5px" }}>
                <h4
                  style={{
                    textAlign: "left",
                    margin: 0,
                    padding: 0,
                    marginTop: "-10px",
                    marginBottom: "3px",
                  }}
                >
                  Transfer Cart
                </h4>
                <TableContainer>
                  <Table
                    className={classes.table}
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>SL</TableCell>
                        <TableCell align="left">Product</TableCell>
                        <TableCell align="left">Brand</TableCell>
                        <TableCell align="left">From Floor</TableCell>
                        <TableCell align="left">From Rack</TableCell>
                        <TableCell align="left">To Floor</TableCell>
                        <TableCell align="left">To Rack</TableCell>
                        <TableCell align="right">Purchase Rate</TableCell>
                        <TableCell align="right">Quantity</TableCell>
                        <TableCell align="right">Total Amount</TableCell>
                        <TableCell align="right">Remove</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {cart.map((product, sl) => (
                        <TableRow key={parseFloat(sl) + 1}>
                          <TableCell>{parseFloat(sl) + 1}</TableCell>
                          <TableCell align="left">
                            {product.prod_name}
                          </TableCell>
                          <TableCell align="left">
                            {product.prod_brand}
                          </TableCell>
                          <TableCell align="left">{product.from_floor_name}</TableCell>
                          <TableCell align="left">{product.from_rack_name}</TableCell>
                          <TableCell align="left">{product.to_floor_name}</TableCell>
                          <TableCell align="left">{product.to_rack_name}</TableCell>
                          <TableCell align="right">
                            {parseFloat(product.prod_purchase_rate || 0).toFixed(2)}
                          </TableCell>
                          <TableCell align="right">
                            {product.prod_qty}
                          </TableCell>
                          <TableCell align="right">
                            {product.prod_total}
                          </TableCell>
                          <TableCell align="right">
                            <RemoveCircleIcon
                              style={{
                                cursor: "pointer",
                                color: "#FF0202",
                                marginLeft: "2px",
                              }}
                              onClick={() => {
                                cartFromRemove(sl);
                              }}
                            ></RemoveCircleIcon>
                          </TableCell>
                        </TableRow>
                      ))}

                      {cart.length != 0 ? (
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell>
                            Total : {parseFloat(total).toFixed(2)}
                          </TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Paper className={classes.paper}>
            <Grid container style={{ paddingRight: "1px" }}>
              <Grid item xs={12} sm={12} style={{ marginBottom: "1px" }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    style={{ width: "100%", marginTop: "" }}
                    value={selectedDate}
                    inputRef={dateRef}
                    onChange={handleDateChangeSet}
                    name="sale_date"
                    label="Transfer Date"
                    format="yyyy/MM/dd"
                  />
                </MuiPickersUtilsProvider>
              </Grid>

              <Grid item xs={12} sm={12} style={{ marginBottom: "10px" }}>
                <TextareaAutosize
                  onChange={(e) => {
                    note_set(e.target.value);
                  }}
                  value={note}
                  name="note"
                  style={{ float: "left", marginTop: "20px", width: "100%" }}
                  aria-label="Transfer Note..."
                  rowsMin={3}
                  placeholder="Transfer Note..."
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <TextField
                  type="number"
                  style={{ marginRight: "5px" }}
                  label="Transfer Total Amount"
                  size="small"
                  value={parseFloat(total).toFixed(2)}
                  name="total_amount"
                  disabled
                  onChange={(e) => total_set(e.target.value)}
                  variant="outlined"
                  className={classes.inputField}
                />
              </Grid>
            </Grid>

            <Grid container style={{ paddingRight: "1px" }}>
              <Grid item xs={12} sm={6}>
                <Button
                  style={{ marginTop: "5px", fontSize: "18px", float: "left" }}
                  variant="contained"
                  color="primary"
                  size="small"
                  buttonRef={transferRef}
                  onClick={() => {
                    transferAction();
                  }}
                  className={classes.button}
                  disabled={saveLoading ? true : false}
                  startIcon={<SaveIcon />}
                >
                  Transfer
                </Button>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button
                  style={{ marginTop: "5px", fontSize: "10px", float: "right" }}
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => window.location.reload()}
                  className={classes.button}
                  startIcon={<SaveIcon />}
                >
                  New Transfer
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  inputField: {
    width: "100%",
    marginTop: "5px",
  },
  plusLinkDiv: {
    position: "relative",
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: "-21px",
    fontSize: "29px",
    height: "21px",
    textAlign: "right",
    position: "absolute",
    right: 0,
    color: "#3e8d54",
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
  };
};
export default connect(mapStateToPops, { currentRouteSet })(TransferEntry);
